import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import { FLAT_FORM_CONTRACT_ID_FIELD_MAX_LENGTH } from '../../FlatForm.constants'

function ContractIdField(props) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      {...props}
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Flat.ContractIdLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={FLAT_FORM_CONTRACT_ID_FIELD_MAX_LENGTH}
      placeholder={t('Flat.ContractIdPlaceholderKey')}
    />
  )
}

export default ContractIdField
